(() => {
  'use strict';
  const flT = globalThis.FellinoI18n.text;
  const titles = [flT("s4c3db82295f6"), flT("s932037640aed"), flT("sb5dfbf5a7a15"), flT("sb3069544681b"), flT("sa0da19ebd570")];
  const stages = { puppy: flT("s3dc50f00e7c1"), adult: flT("sbeea7433cc68"), senior: 'Senior' };
  const formats = { wet: flT("s77d23688f305"), dry: flT("see6ddeaf6113"), both: flT("s9101c5011a2a") };
  const activities = { low: flT("s8221a5947771"), normal: flT("sba8eb0e6aa90"), high: flT("sebe21bedcde8") };
  const proteins = { poultry: flT("sab724879badc"), beef: flT("s96e8f7844500"), fish: flT("s99a8a81500a0"), lamb: flT("sb831bb648deb"), pork: flT("sacb514d5dc40"), horse: flT("s954f0a2d53ee"), egg: flT("sa252f7aeeb24") };
  const node = (tag, cls, value) => { const n = document.createElement(tag); if (cls) n.className = cls; if (value !== undefined) n.textContent = value; return n; };
  function packageKilograms(title) {
    // Use declared net contents, never Shopify's shipping weight.
    const match = String(title || '').trim().match(/^(?:(?:Karton|Carton|Box)\s*\()?\s*(?:(\d+)\s*[x×]\s*)?(\d+(?:[.,]\d+)?)\s*(kg|g)\s*\)?$/i);
    if (!match) return null;
    const kg = Number(match[1] || 1) * Number(match[2].replace(',', '.')) / (match[3].toLowerCase() === 'g' ? 1000 : 1);
    return kg > 0 ? kg : null;
  }
  function recipeHash(raw) {
    const decoder = document.createElement('textarea');
    decoder.innerHTML = String(raw || '').replace(/<[^>]*>/g, ' ');
    const plain = decoder.value.replace(/\s+/g, ' ').trim();
    let hash = 2166136261;
    for (let i = 0; i < plain.length; i++) hash = Math.imul(hash ^ plain.charCodeAt(i), 16777619) >>> 0;
    return hash.toString(16).padStart(8, '0');
  }
  function eligible(food, p) {
    if (p.health !== 'healthy' || p.months < 2 || p.stage === 'puppy' && p.months > 24) return false;
    if (p.stage === 'puppy' ? food.stage !== 'puppy' : p.stage === 'adult' ? food.stage !== 'adult' : food.stage === 'puppy') return false;
    if (p.months < food.minAge || p.months > food.maxAge) return false;
    if (p.size < food.minWeight || p.size > food.maxWeight) return false;
    if (p.format !== 'both' && food.form !== p.format) return false;
    if (p.grainFree && !food.grainFree) return false;
    if (p.avoid.length && (food.unknownProtein || p.avoid.some(x => food.proteins.includes(x)))) return false;
    // Light recipes are only an option for healthy, adult, castrated dogs with a calm routine.
    if (food.light && (p.stage !== 'adult' || p.neutered !== 'yes' || p.activity !== 'low')) return false;
    if (food.feeding !== undefined && (!window.FellinoFeeding || !window.FellinoFeeding.portion(food, p))) return false;
    return true;
  }
  function ranked(foods, p) {
    const pool = foods.filter(f => eligible(f, p));
    const result = [];
    const score = f => (f.stage === p.stage ? 60 : 0) + (f.maxWeight < 150 || f.minWeight > 0 ? 12 : 0) + (f.light ? 10 : 0);
    while (pool.length) {
      pool.sort((a, b) => {
        const adjusted = f => score(f) - result.filter(x => x.brand === f.brand).length * 18 - (p.format === 'both' ? result.filter(x => x.form === f.form).length * 24 : 0);
        return adjusted(b) - adjusted(a);
      });
      result.push(pool.shift());
    }
    return result;
  }
  async function jsonRequest(url, signal) {
    const controller = new AbortController();
    const cancel = () => controller.abort();
    if (signal) { if (signal.aborted) cancel(); else signal.addEventListener('abort', cancel, { once: true }); }
    const timer = setTimeout(cancel, 12000);
    try {
      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(flT("s38000c9db0f7"));
      return await response.json();
    } finally { clearTimeout(timer); if (signal) signal.removeEventListener('abort', cancel); }
  }
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const steps = Array.from(form.querySelectorAll('[data-step]'));
    const results = root.querySelector('[data-results]');
    const body = root.querySelector('[data-result-body]');
    const intro = root.querySelector('[data-result-intro]');
    const resultTitle = root.querySelector('[data-result-title]');
    const error = root.querySelector('[data-error]');
    const next = root.querySelector('.ffa-next');
    const base = String(root.dataset.root || '/').replace(/\/?$/, '/');
    const money = new Intl.NumberFormat((globalThis.FellinoI18n?.locale || 'de-DE'), { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });
    let step = 0, controller, catalogPromise, generation = 0, returnStep = 0;
    const read = () => {
      const d = new FormData(form), age = Number(d.get('age')), weight = Number(d.get('weight'));
      return { stage: d.get('stage'), age, ageUnit: d.get('ageUnit'), months: age * (d.get('ageUnit') === 'years' ? 12 : 1), weight, size: d.get('stage') === 'puppy' ? Number(d.get('adultWeight')) : weight, activity: d.get('activity'), neutered: d.get('neutered'), health: d.get('health') === 'guided' ? 'healthy' : d.get('health'), guided: d.get('health') === 'guided', format: d.get('format'), grainFree: d.has('grainFree'), avoid: d.getAll('avoid') };
    };
    function profile() {
      const p = read(), text = [];
      if (p.stage) text.push(stages[p.stage]);
      if (p.age > 0) text.push(`${p.age.toLocaleString((globalThis.FellinoI18n?.locale || 'de-DE'))} ${p.ageUnit === 'years' ? flT("s48f9373038f0") : flT("sf8d905a1e383")}`);
      if (p.weight > 0) text.push(`${p.weight.toLocaleString((globalThis.FellinoI18n?.locale || 'de-DE'))} kg${p.stage === 'puppy' && p.size ? flT("s868e1e6b74cf",[ p.size.toLocaleString((globalThis.FellinoI18n?.locale || 'de-DE')) ]) : ''}`);
      if (p.activity) text.push(activities[p.activity]);
      if (p.neutered) text.push(p.neutered === 'yes' ? flT("s4f663e5337d5") : flT("sff3f465c2d5a"));
      if (p.health) text.push(p.health === 'healthy' ? p.guided ? flT("s43d16bbb037d") : flT("s20ceddd2a80d") : flT("s7919694f1275"));
      if (p.format) text.push(formats[p.format]);
      if (p.grainFree) text.push(flT("sf8d1aa80ca5e"));
      if (p.avoid.length) text.push(flT("s9643ed50f5f2",[ p.avoid.map(x => proteins[x]).join(', ') ]));
      root.querySelector('.ffa-profile').hidden = text.length === 0;
      root.querySelector('[data-profile]').textContent = text.join('\n');
    }
    function show(index, focus = true) {
      step = index; steps.forEach((s, i) => { s.hidden = i !== index; });
      form.hidden = false; results.hidden = true;
      root.querySelector('.ffa-progress').hidden = false;
      root.querySelector('[data-step-label]').textContent = flT("s79551dc17d91",[ index + 1 ]);
      root.querySelector('[data-step-title]').textContent = titles[index];
      root.querySelector('progress').value = index + 1;
      root.querySelector('[data-back]').hidden = index === 0;
      next.textContent = index === 4 ? flT("sce56587a9843") : flT("sb3e3f54b2131");
      error.hidden = true; error.textContent = '';
      if (focus) { steps[index].querySelector('legend').focus({ preventScroll: true }); steps[index].scrollIntoView({ block: 'start', behavior: 'auto' }); }
    }
    function invalid(text, input) {
      error.textContent = text; error.hidden = false;
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
      return false;
    }
    function validate() {
      for (const input of steps[step].querySelectorAll('input, select')) {
        input.removeAttribute('aria-invalid');
        if (input.closest('[hidden]')) continue;
        if (!input.checkValidity()) return invalid(input.type === 'radio' ? flT("s62c53f4e2b2d") : flT("s9d489c945a6b",[ input.name === 'weight' ? flT("s1fb9896bc93c") : input.name === 'adultWeight' ? flT("s92083cd53bbf") : flT("s12e69a668531") ]), input);
      }
      if (step === 0) {
        const p = read();
        if (p.months > 300 || p.months <= 0) return invalid(flT("s038cc4b6154f"), form.elements.age);
        if (p.stage === 'puppy' && p.size < p.weight) return invalid(flT("seb66befe667c"), form.elements.adultWeight);
        if (p.stage === 'adult' && p.months < 10) return invalid(flT("sf2a5247dac96"), form.elements.stage[0]);
        if (p.stage === 'senior' && p.months < 60) return invalid(flT("s1fec74bd03f1"), form.elements.age);
      }
      return true;
    }
    function contactMessage(title, text) {
      const box = node('div', 'ffa-message'); box.append(node('h3', '', title), node('p', '', text));
      const link = node('a', 'ffa-link-button', flT("s8e85d873453f")); link.href = root.dataset.contact; box.append(link); body.append(box);
    }
    function feedingPlanner(matches, p) {
      const engine = window.FellinoFeeding;
      const panel = node('section', 'ffa-plan');
      const heading = node('h3', '', flT("s25a14ebad691")); heading.tabIndex = -1;
      panel.append(heading, node('p', 'ffa-plan-intro', flT("s461f5400671f")));
      const controls = node('div', 'ffa-plan-controls');
      function select(label, options, key) {
        const wrap = node('label', 'ffa-plan-field', label), input = node('select'); input.dataset.plan = key;
        options.forEach(([value, text]) => { const option = node('option', '', text); option.value = value; input.append(option); });
        wrap.append(input); controls.append(wrap); return input;
      }
      const chosen = select(flT("sfb4bbfb96e5a"), matches.map(m => [m.food.handle, m.product.title]), 'food');
      const mode = select(flT("s80adefd78c11"), [['single', flT("s82a0559cb2c5")], ['mixed', flT("s588017e19fa9")]], 'mode');
      const secondary = select(flT("sd6e8adbb5991"), [], 'other');
      const share = select(flT("sa2bf9a00410e"), [[25, flT("se00478ae21b9")], [50, flT("se7f77b5646d3")], [75, flT("s1f03081249a5")]], 'share'); share.value = '50';
      const minimumMeals = p.stage === 'puppy' && p.months < 6 ? 3 : 2;
      const mealCount = select(flT("s7ffc51ba7fec"), [2, 3, 4].filter(n => n >= minimumMeals).map(n => [n, flT("sc2c95c5598f1",[ n ])]), 'meals'); mealCount.value = String(p.stage === 'puppy' ? 3 : 2);
      const snacks = select(flT("s9f211bc38018"), [[0, flT("s03825a027601")], [5, flT("s0a2d939e0d90")], [10, flT("sc1f594378b34")]], 'snacks');
      const packageOne = select(flT("sbd3750ba133c"), [], 'package');
      const packageTwo = select(flT("s8c8918dad936"), [], 'otherPackage');
      panel.append(controls);
      const mixingHint = node('p', 'ffa-note'); panel.append(mixingHint);
      const output = node('div', 'ffa-plan-output'); output.setAttribute('aria-live', 'polite'); output.setAttribute('aria-atomic', 'true'); panel.append(output);
      const basis = node('details', 'ffa-plan-basis'); basis.append(node('summary', '', flT("s85257e121b40")));
      const basisBody = node('div'); basis.append(basisBody); panel.append(basis);
      const metric = (label, value) => { const box = node('div', 'ffa-plan-metric'); box.append(node('small', '', label), node('strong', '', value)); return box; };
      const match = handle => matches.find(x => x.food.handle === handle);
      const n = (value, digits = 0) => Number(value).toLocaleString((globalThis.FellinoI18n?.locale || 'de-DE'), { maximumFractionDigits: digits });
      function packageOptions(input, m) {
        const old = input.value;
        const variants = m.product.variants.filter(v => v.available && v.price > 0);
        input.replaceChildren();
        variants.forEach(v => { const text = v.public_title || (v.title === 'Default Title' ? flT("sdc4df0597b3f") : v.title); const option = node('option', '', `${text} · ${money.format(v.price / 100)}`); option.value = v.id; input.append(option); });
        if (variants.some(v => String(v.id) === old)) { input.value = old; return; }
        const target = engine.portion(m.food, p).daily * 7 / 1000;
        const sizes = variants.map(v => ({ variant: v, kg: packageKilograms(v.netContentsTitle || v.public_title || v.title) })).filter(x => x.kg).sort((a, b) => a.kg - b.kg);
        const suitable = sizes.find(x => x.kg >= target) || sizes.at(-1);
        if (suitable) input.value = String(suitable.variant.id);
      }
      function refreshProducts() {
        const main = match(chosen.value);
        const others = matches.filter(m => m.food.form !== main.food.form && m.food.kcal100 && main.food.kcal100);
        const previous = secondary.value; secondary.replaceChildren();
        others.forEach(m => { const option = node('option', '', m.product.title); option.value = m.food.handle; secondary.append(option); });
        if (others.some(m => m.food.handle === previous)) secondary.value = previous;
        mode.options[1].disabled = !others.length;
        if (!others.length) mode.value = 'single';
        mixingHint.textContent = others.length ? flT("s582f693602e9") : p.format === 'both' ? flT("s8bba0b070943") : flT("sffb85b43c8cf");
        packageOptions(packageOne, main);
        if (others.length) packageOptions(packageTwo, match(secondary.value));
      }
      function render() {
        const main = match(chosen.value), other = mode.value === 'mixed' ? match(secondary.value) : null;
        const mixed = Boolean(other);
        [secondary, share, packageTwo].forEach(input => { input.closest('label').hidden = !mixed; });
        const result = engine.plan(main.food, p, { meals: Number(mealCount.value), snack: Number(snacks.value), wetPercent: Number(share.value), other: other?.food });
        output.replaceChildren(); basisBody.replaceChildren();
        if (result.error) { output.append(node('p', 'ffa-error', result.error)); return; }
        const doses = node('div', 'ffa-plan-doses');
        let dailyCost = 0, allCostsKnown = true;
        result.amounts.forEach((amount, index) => {
          const m = index === 0 ? main : other;
          const variants = m.product.variants, variant = variants.find(v => String(v.id) === (index === 0 ? packageOne.value : packageTwo.value));
          const kg = packageKilograms(variant?.netContentsTitle || variant?.public_title || variant?.title);
          const block = node('div', 'ffa-plan-dose'); block.dataset.dose = amount.food.handle;
          block.append(node('small', '', formats[amount.food.form]), node('h4', '', m.product.title), node('strong', 'ffa-daily', flT("s0ca4b97a4f50",[ n(amount.grams) ])));
          block.append(node('p', 'ffa-meal-amount', flT("s23bdd77aacb2",[ result.count, amount.meals.map(g => `${n(g)} g`).join(' + ') ])));
          block.append(node('p', 'ffa-weekly', flT("s78192d79a124",[ n(amount.weeklyKg, 2) ])));
          if (kg && variant) { const cost = variant.price / 100 / (kg * 1000) * amount.grams; dailyCost += cost; block.append(node('small', '', flT("s5da4d399c1c7",[ money.format(cost) ]))); }
          else allCostsKnown = false;
          if (variant) { const link = node('a', 'ffa-plan-product-link', flT("s0e3524bfa855")); link.href = `${base}products/${encodeURIComponent(m.food.handle)}?variant=${encodeURIComponent(variant.id)}`; block.append(link); }
          doses.append(block);
        });
        output.append(doses);
        const metrics = node('div', 'ffa-plan-metrics');
        if (result.totalKcal !== null) metrics.append(metric(flT("s8a53a2a71292"), flT("sbf4e3a0f53ec",[ n(result.totalKcal) ])));
        if (result.snack > 0) metrics.append(metric(flT("s8347bc407da9"), result.snackKcal === null ? flT("sa908f010431b",[ result.snack ]) : flT("s7c86a1bbe75f",[ n(result.snackKcal) ])));
        else metrics.append(metric(flT("s84fffb62bf66"), flT("s7a6215990c17")));
        if (allCostsKnown) metrics.append(metric(flT("s90ec7abbe484"), flT("s951262cb66bb",[ money.format(dailyCost) ])));
        output.append(metrics, node('p', 'ffa-plan-note', flT("secfea9b7fe10")));
        const reference = result.base;
        basisBody.append(node('p', '', flT("s63c693bd8196",[ main.product.title, n(reference.daily), reference.low !== reference.high ? flT("s302d9570ee63",[ n(reference.low), n(reference.high) ]) : '', p.stage === 'puppy' ? flT("s5341f5bdb6ff",[ n(p.months, 1), n(p.size, 1) ]) : flT("s65112cb98469",[ n(p.weight, 1) ]), reference.label, reference.between ? flT("sc38c7c022e51") : '' ])));
        if (reference.caution) basisBody.append(node('p', '', reference.caution));
        const source = node('a', '', reference.mode === 'energy' ? flT("sac00e054b3c8") : flT("s53191b697f67")); source.href = reference.source; source.target = '_blank'; source.rel = 'noopener'; basisBody.append(source);
        if (main.food.kcal100) basisBody.append(node('p', '', flT("s0e75757368bc",[ n(main.food.kcal100, 1), mixed ? flT("se76241ec319b",[ n(Number(share.value)), 100 - Number(share.value) ]) : '' ])));
        else basisBody.append(node('p', '', flT("s124239339ffd")));
        if (p.neutered === 'yes') basisBody.append(node('p', '', reference.mode === 'table' ? flT("s6a0f2226dd44") : flT("sb62735b9a623")));
        basisBody.append(node('p', '', flT("s4197abd378e2")));
      }
      controls.addEventListener('change', e => {
        if (e.target === chosen) refreshProducts();
        if (e.target === secondary) packageOptions(packageTwo, match(secondary.value));
        render();
      });
      refreshProducts(); render();
      return { panel, choose(handle) { chosen.value = handle; refreshProducts(); render(); heading.focus(); panel.scrollIntoView({ block: 'start', behavior: 'auto' }); } };
    }
    function card(food, product, chooseFood) {
      const available = product.variants.filter(v => v.available && Number.isFinite(v.price) && v.price > 0).sort((a, b) => a.price - b.price);
      const variant = available[0];
      const item = node('article', 'ffa-product');
      const src = product.featured_image || product.images?.[0];
      if (src && /^https:\/\//.test(src.replace(/^\/\//, 'https://'))) { const image = node('img'); image.src = src.replace(/^\/\//, 'https://'); image.alt = product.title; image.loading = 'lazy'; image.width = 220; image.height = 170; item.append(image); }
      const content = node('div', 'ffa-product-content'); content.append(node('small', '', food.brand), node('h3', '', product.title));
      const reasons = [formats[food.form], food.stage === 'puppy' ? flT("se0b7ecc05113") : food.stage === 'senior' ? flT("s6730fb46f6c2",[ food.minAge / 12 ]) : pStageAdult()];
      function pStageAdult() { return read().stage === 'senior' ? flT("sd1d140a69001") : flT("se580951dde3e"); }
      if (food.smallKibble) reasons.push(flT("s56e88cb933e4"));
      else if (food.maxWeight < 150) reasons.push(flT("sb1b3611e8ad0",[ food.minWeight ? `${food.minWeight}–${food.maxWeight}` : flT("sb18ada19f791",[ food.maxWeight ]), read().stage === 'puppy' ? flT("s8ecbf0957cbb") : flT("sf3d6febaac4d") ]));
      else if (food.minWeight > 0) reasons.push(flT("s21e21597c29c",[ food.minWeight, read().stage === 'puppy' ? flT("s8ecbf0957cbb") : '' ]));
      if (food.grainFree) reasons.push(flT("sf2f501494022"));
      if (read().avoid.length) reasons.push(flT("sf01cae81cd30"));
      if (food.light) reasons.push(flT("s2f375ebe94ff"));
      const list = node('ul'); reasons.forEach(x => list.append(node('li', '', x))); content.append(list);
      const portion = window.FellinoFeeding?.portion(food, read());
      if (portion) content.append(node('p', 'ffa-card-ration', flT("s83065bfc4a8b",[ portion.daily.toLocaleString((globalThis.FellinoI18n?.locale || 'de-DE')) ])));
      content.append(node('div', 'ffa-product-price', `${available.length > 1 ? flT("s9893ba826d74") : ''}${money.format(variant.price / 100)}`));
      const packageName = variant.public_title || (variant.title === 'Default Title' ? '' : variant.title);
      content.append(node('span', 'ffa-package', flT("seb15969b322e",[ packageName ? `${packageName} · ` : '' ])));
      if (variant.unit_price && variant.unit_price_measurement) {
        const m = variant.unit_price_measurement;
        content.append(node('small', 'ffa-package', `${money.format(variant.unit_price / 100)} / ${Number(m.reference_value) === 1 ? '' : m.reference_value} ${m.reference_unit}`));
      } else {
        const kilograms = packageKilograms(variant.netContentsTitle || packageName);
        if (kilograms) content.append(node('small', 'ffa-package', `${money.format(variant.price / 100 / kilograms)} / kg`));
      }
      if (chooseFood) { const select = node('button', 'ffa-plan-select', flT("s8e6e36c0dcfc")); select.type = 'button'; select.addEventListener('click', () => chooseFood(food.handle)); content.append(select); }
      const link = node('a', 'ffa-link-button', flT("sbb3e3cf97a19")); link.href = `${base}products/${encodeURIComponent(food.handle)}?variant=${encodeURIComponent(variant.id)}`; content.append(link); item.append(content); return item;
    }
    async function recommend() {
      const p = read(), current = ++generation;
      controller?.abort(); controller = new AbortController();
      form.hidden = true; root.querySelector('.ffa-progress').hidden = true; results.hidden = false; body.replaceChildren();
      returnStep = step === 2 && p.health !== 'healthy' ? 2 : 0;
      root.querySelector('[data-restart]').textContent = returnStep === 2 ? flT("s0d569ebc7279") : flT("s37e4d9e80536");
      intro.textContent = ''; resultTitle.textContent = flT("s671871fa4100"); resultTitle.focus({ preventScroll: true }); results.scrollIntoView({ block: 'start', behavior: 'auto' });
      if (p.health !== 'healthy' || p.months < 2 || p.stage === 'puppy' && p.months > 24) {
        resultTitle.textContent = p.health === 'healthy' ? flT("sebc937afbfe5") : flT("sd1bf41eebf62");
        intro.textContent = flT("sfb099be7b57a");
        const explanation = node('div', 'ffa-message');
        explanation.append(node('h3', '', flT("sc822b7dccc18")), node('p', '', p.health === 'healthy' ? flT("sbf6f422811dd") : p.health === 'unsure' ? flT("s8ed8a22e52a1") : flT("sf6ade9ec6900")));
        explanation.append(node('p', '', flT("sd17bf55d2a9d")));
        body.append(explanation);
        contactMessage(flT("s0760d984b2a7"), flT("s1e6832e67e30"));
        body.querySelector('.ffa-link-button').textContent = flT("s7e05620abc13");
        return;
      }
      results.setAttribute('aria-busy', 'true');
      const loading = node('p', 'ffa-loading', flT("s18d23c7bb1da")); loading.prepend(node('span', 'ffa-spinner')); loading.setAttribute('role', 'status'); body.append(loading);
      try {
        if (!catalogPromise) catalogPromise = jsonRequest(root.dataset.catalog).catch(e => { catalogPromise = null; throw e; });
        const catalog = await catalogPromise;
        if (current !== generation) return;
        const candidates = ranked(catalog.products, p), matches = [];
        let failed = 0;
        for (let i = 0; i < candidates.length && matches.length < 4; i += 4) {
          const batch = candidates.slice(i, i + 4);
          const responses = await Promise.allSettled(batch.map(async f => { const url = `products/${encodeURIComponent(f.handle)}.js`; const [product, original] = await Promise.all([jsonRequest(base + url, controller.signal), base === '/' ? null : jsonRequest('/' + url, controller.signal)]); return { product, original: original || product }; }));
          if (current !== generation) return;
          responses.forEach((r, j) => {
            if (r.status !== 'fulfilled') { failed++; return; }
            const { product, original } = r.value, food = batch[j];
            if (original.handle !== food.handle || String(product.id) !== String(original.id) || recipeHash(original.description) !== food.recipe || !product.variants?.some(v => v.available && Number.isFinite(v.price) && v.price > 0)) return;
            product.variants = product.variants.map(v => ({...v, netContentsTitle: original.variants.find(o => String(o.id) === String(v.id))?.title || v.title}));
            matches.push({ food, product });
          });
        }
        body.replaceChildren();
        if (!matches.length) {
          resultTitle.textContent = flT("s0230ce186e4d");
          intro.textContent = failed ? flT("sb1cdfd7c178c") : flT("s75018a9d552a");
          contactMessage(flT("s46af881b9614"), flT("sd9a20229a4e0"));
          return;
        }
        intro.textContent = flT("se601b5b77350");
        const tags = node('div', 'ffa-summary-tags'); [stages[p.stage], formats[p.format], ...(p.grainFree ? [flT("sefa327650e0e")] : [])].forEach(x => tags.append(node('span', '', x))); body.append(tags);
        const selectedMatches = matches.slice(0, 4);
        const planner = window.FellinoFeeding && selectedMatches.every(m => window.FellinoFeeding.portion(m.food, p)) ? feedingPlanner(selectedMatches, p) : null;
        if (planner) body.append(planner.panel);
        body.append(node('h3', 'ffa-products-heading', flT("s5b8b13dc1520")));
        const grid = node('div', 'ffa-result-grid'); selectedMatches.forEach(({ food, product }) => grid.append(card(food, product, planner?.choose))); body.append(grid);
        body.append(node('p', 'ffa-results-note', flT("scc80ba81e403")));
        if (failed) body.append(node('p', 'ffa-results-note', flT("s433b3d698a83")));
      } catch (e) {
        if (current !== generation) return;
        body.replaceChildren(); intro.textContent = flT("s9f6cd912ec4f");
        contactMessage(flT("s2b418ae47125"), flT("sfdbf5d1fa663"));
      } finally { if (current === generation) results.setAttribute('aria-busy', 'false'); }
    }
    form.addEventListener('submit', e => { e.preventDefault(); if (!validate()) return; profile(); if (step < 4) show(step + 1); else recommend(); });
    form.addEventListener('input', profile);
    form.addEventListener('change', e => {
      if (e.target.name === 'stage') {
        const puppy = e.target.value === 'puppy'; root.querySelector('[data-puppy-field]').hidden = !puppy; form.elements.adultWeight.required = puppy;
        form.elements.ageUnit.value = puppy ? 'months' : 'years'; form.elements.age.max = puppy ? '300' : '25';
      }
      if (e.target.name === 'ageUnit') form.elements.age.max = e.target.value === 'months' ? '300' : '25';
      profile();
      if (e.target.name === 'health' && step === 2 && ['care', 'unsure'].includes(e.target.value)) recommend();
    });
    root.querySelector('[data-back]').addEventListener('click', () => show(step - 1));
    root.querySelector('[data-restart]').addEventListener('click', () => { ++generation; controller?.abort(); results.setAttribute('aria-busy', 'false'); show(returnStep); });
    show(0, false);
  }
  document.querySelectorAll('[data-food-advisor]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-food-advisor]').forEach(init));
})();
